// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__BEwKl","lds-ring":"Loader_lds-ring__P9hsb"};